import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { ReorderCardInStatus } from '../../../api/commands';
import orderBy from 'lodash/orderBy';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ReorderCardInTrackingStatus extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ReorderCardInTrackingStatus';

    public constructor(public cardId: string, public statusKey: number, public index: number) {
        super(ReorderCardInTrackingStatus.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ReorderCardInTrackingStatus): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () => new ReorderCardInStatus(action.cardId, state.id, action.statusKey, action.index)
    });
    return true;
};

const reducer = (state: StorymapState, action: ReorderCardInTrackingStatus): void => {
    const subtask = state.subtasks.find(x => x.id == action.cardId);
    const cardsInStatus = orderBy(state.subtasks.filter(x => x.status == action.statusKey && x.releaseId == subtask.releaseId && x.id != action.cardId), x => x.releaseViewOrder);

    cardsInStatus.forEach((card, i) => {
        card.releaseViewOrder = i;
    });

    cardsInStatus.forEach((card, i) => {
        if (i >= action.index) {
            card.releaseViewOrder = i + 1;
        }
    });

    subtask.releaseViewOrder = action.index;
};

//@ts-ignore
registerMiddleware(ReorderCardInTrackingStatus.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ReorderCardInTrackingStatus.ACTION_TYPE, reducer);